import { isFirstPageInBrowserSession } from './teacherPageAttribution.js';

export function validateQuickDonation(donationForm) {
    if (donationForm === undefined) {
        donationForm = document.quickDonate;
    }
    const sanitizedDonationAmount = sanitizeAndValidateDonationAmount(donationForm, donationForm.donationAmount);
    if (!sanitizedDonationAmount) {
        return returnFalse();
    }
    try {
        dcAnalytics.trackEventGA([pageName, 'Quick Donation', 'Submit']);
        const quickDonationDetails = { 'Page Name': pageName, 'Add To Cart Price': sanitizedDonationAmount };
        if (donationForm.schoolid) {
            quickDonationDetails['Quick Donation to School'] = donationForm.schoolid;
        } else if (donationForm.teacherid) {
            quickDonationDetails['Quick Donation to Teacher'] = donationForm.teacherid;
        } else if (donationForm.challengeid) {
            quickDonationDetails['Quick Donation to Challenge'] = donationForm.challengeid;
        }
        dcAnalytics.track('Added to Shopping Cart', quickDonationDetails);
    } catch (err) {
        // do nothing
    }
    return true;
}

export function validateInspireForm(frm) {
    const trackInspireFormSubmit = function (amount) {
        dcAnalytics.trackEventGA([pageName, 'TeacherGC']);
        dcAnalytics.track('Added to Shopping Cart', {
            'Page Name': pageName,
            'Add To Cart Price': amount,
            'Gift Code to Teacher': teacherId,
        });
    };

    const validateInspireFormCallback = function () {
        if (validateInspireForm(frm)) {
            trackInspireFormSubmit((frm.amount) ? frm.amount : 0);
            frm.submit();
            hideHTMLLightbox();
        }
    };

    const donationAmount = frm.amount;
    const sanitizedDonationAmount = sanitizeAndValidateDonationAmount(frm, donationAmount, validateInspireFormCallback);
    if (!sanitizedDonationAmount) {
        return returnFalse();
    }

    if (donationAmount.value % 1 > 0) {
        dcAnalytics.trackEventGA([pageName, 'Error - Whole Dollars']);
        showDonationAmountAlert(frm, validateInspireFormCallback, 'Please enter a whole number of dollars.<br />');
        return returnFalse();
    }
    if (donationAmount.value < 10) {
        dcAnalytics.trackEventGA([pageName, 'Error - Minimum Amount']);
        showDonationAmountAlert(frm, validateInspireFormCallback, 'Sorry, the minimum amount for a gift card is $10.<br />');
        return returnFalse();
    }
    if (donationAmount.value > 100000) {
        dcAnalytics.trackEventGA([pageName, 'Error - Maximum Amount']);
        showDonationAmountAlert(frm, validateInspireFormCallback, "Whoa there, we can't handle any gift cards purchases over $100,000.<br />");
        return returnFalse();
    }

    trackInspireFormSubmit((frm.amount) ? frm.amount.value : 0);
    return true;
}

export function validateRecurringDonationForm(frm) {
    const validateRecurringDonationFormCallback = function () {
        if (validateRecurringDonationForm(frm)) {
            frm.submit();
            hideHTMLLightbox();
        }
    };

    const donationAmount = frm.donationAmount;
    const sanitizedDonationAmount = sanitizeAndValidateDonationAmount(frm, donationAmount, validateRecurringDonationFormCallback);
    if (!sanitizedDonationAmount) {
        return returnFalse();
    }

    if (donationAmount.value % 1 > 0) {
        dcAnalytics.trackEventGA([pageName, 'Error - Whole Dollars']);
        showDonationAmountAlert(frm, validateRecurringDonationFormCallback, 'Please enter a whole number of dollars.<br />');
        return returnFalse();
    }
    if (donationAmount.value < 1) {
        dcAnalytics.trackEventGA([pageName, 'Error - Minimum Amount']);
        showDonationAmountAlert(frm, validateRecurringDonationFormCallback, 'Please enter at least $1.<br />');
        return returnFalse();
    }
    if (donationAmount.value > 1000) {
        dcAnalytics.trackEventGA([pageName, 'Error - Maximum Amount']);
        showDonationAmountAlert(frm, validateRecurringDonationFormCallback, 'Please <a href="../help/donor_contact_form.html?supportCategory=62">contact our team</a> to make a monthly donation over $1,000.<br />');
        return returnFalse();
    }
    return true;
}

function showDonationAmountAlert(frm, callback, errorMessage) {
    if (errorMessage === undefined) {
        errorMessage = 'Please enter a dollar amount for your donation.';
    }

    // Add the donationAmountAlertForm if none is present
    if ($('#donationAmountAlertForm').length === 0) {
        showHTMLLightBox($('<form id="donationAmountAlertForm" class="form-redux"><p><strong id="dialogTitle">' + errorMessage + '</strong></p><div class="dollar-amount"><input type="tel" id="donationAmountAlert" name="donationAmount" value="" aria-labelledby="dialogTitle" autofocus/></div><input type="submit" class="button-primary small heap-give-button" value="Give"/><p>Redeeming a gift card? Enter your code during checkout.</p></form>'));

        $('#donationAmountAlertForm').submit(function (e) {
            e.preventDefault();
            if ($(frm).find('.dAmount').length > 0) {
                $(frm).find('.dAmount').val($('#donationAmountAlert').val());
            } else if ($(frm).find('.ddInput').length > 0) {
                $(frm).find('.ddInput').val($('#donationAmountAlert').val());
            } else if (frm.donationAmount) {
                frm.donationAmount.value = $('#donationAmountAlert').val();
            } else if (frm.amount) {
                frm.amount.value = $('#donationAmountAlert').val();
            }
            if (callback) {
                callback(frm);
            } else if (frm.name.indexOf('quickDonate') === 0 && validateQuickDonation(frm)) {
                frm.submit();
                hideHTMLLightbox();
            } else if ((pageName == 'proposal' || pageName == 'project' || pageName == 'cart') && checkDonationAmount(frm)) {
                frm.submit();
                hideHTMLLightbox();
            } else {
                const result = ajaxAddToCartSubmit(frm);
                if (result) {
                    hideHTMLLightbox();
                }
            }
        });
    } else {
        // If we already have a donationAmountAlertForm, just update its
        // title with the new error message
        $('#dialogTitle').html(errorMessage);
    }

    // Add a progress bar to this donation amount form (unless one's already present)
    const alreadyCloned = $('#cloned-progress-bar').length > 0;
    if (!alreadyCloned && $('.js-progress-bar-wrapper').length > 0) { // project page
        const newProgressBar = $('.js-progress-bar-wrapper').eq(0).clone();
        newProgressBar.css('margin-bottom', '1.5em')
            .attr('id', 'cloned-progress-bar')
            .prependTo('#donationAmountAlertForm');
    } else if (!alreadyCloned && $('.js-progress-bar-holder').length > 0) { // search page
        const newProgressBar = $(frm).closest('.js-project-card-give-box').siblings('.js-progress-bar-holder').clone();
        newProgressBar.css('margin-bottom', '1.5em')
            .attr('id', 'cloned-progress-bar')
            .prependTo('#donationAmountAlertForm');
        const newProjectData = $(frm).closest('.js-project-card-give-box').siblings('.js-project-data').clone();
        newProjectData.css('margin-bottom', '.5em').prependTo('#donationAmountAlertForm');
    }
}

// for project page where the form submits directly
export function checkDonationAmount(frm) {
    const sanitizedDonationAmount = sanitizeAndValidateDonationAmount(frm, frm.donationAmount);
    if (!sanitizedDonationAmount) {
        return returnFalse();
    }

    trackProjectGiveWidget(frm, sanitizedDonationAmount);

    // Make sure donations from a GP are counted even if they click over to the project page
    const href = location.href;
    if (!frm.referrer.value && href.indexOf('/project/') > 0 && href.indexOf('challengeid=') > 0) {
        frm.referrer.value = document.referrer;
    }

    updateChallengeIdFieldBasedOnRFParam(frm);
    return true;
}

/**
 * @param frm
 * @param callback If provided, we'll call this callback with the server
 * response. Defaults to ajaxAddToCartStatus.
 * @returns {boolean|*}
 */
export function ajaxAddToCartSubmit(frm, callback) {
    createCookieWithSameSiteNone('hasCookies', 'true', 0);
    if (readCookie('hasCookies') == null) {
        alert('You must enable cookies and Javascript to proceed.');
        return false;
    }

    frm.referrer.value = encodeURIComponent(location.href);
    frm.lastSearchURL.value = encodeURIComponent(location.href);

    if (typeof donorWishlistId !== 'undefined') { // for projects tab on Donor Profile
        frm.challengeid.value = donorWishlistId;
    } else if (typeof qsParam.challengeid !== 'undefined' && qsParam.challengeid.match(/^[0-9]+$/)) {
        frm.challengeid.value = qsParam.challengeid;
    } else if (typeof isGivingPage !== 'undefined' && isGivingPage) { // for projects tab on Giving Page
        frm.challengeid.value = qsParam.id;
    } else if (typeof pageName !== 'undefined' && pageName == 'teacher_profile' && isFirstPageInBrowserSession()) { // for projects tab on Teacher Page
        frm.challengeid.value = teacherChallengeId;
    }

    const sanitizedDonationAmount = sanitizeAndValidateDonationAmount(frm, frm.donationAmount);
    if (!sanitizedDonationAmount) {
        return returnFalse();
    }

    updateChallengeIdFieldBasedOnRFParam(frm);

    const urlObj = new Uri(frm.action);
    for (let i = 0; i < frm.elements.length; i++) {
        if (frm.elements[i].name != null) {
            urlObj.addQueryParam(frm.elements[i].name, frm.elements[i].value);
        }
    }

    // Default to ajaxAddToCartStatus.
    if (callback == null) {
        callback = ajaxAddToCartStatus;
    }

    $.ajax({
        type: 'GET',
        dataType: 'jsonp',
        url: urlObj.toString(),
    }).done(function (data) {
        callback(data);
        // make sure minicart gets updated using general/miniCartFunctions.js
        if (data && data.sessionMiniCartDetails && typeof refreshMiniCartFromDetailsObject !== 'undefined') {
            refreshMiniCartFromDetailsObject(data.sessionMiniCartDetails);
        }
    }).fail(function () {
        toast('There was a problem adding this project to your cart. Please try again later.');
    });

    $(frm).hide();
    loader.showLoader('#added' + frm.elements.proposalid.value);

    trackProjectGiveWidget(frm, sanitizedDonationAmount, true);

    return true;
}

function trackProjectGiveWidget(frm, donationAmount, isBackgroundSubmit) {
    // GOOGLE ANALYTICS
    if (isBackgroundSubmit) {
        dcAnalytics.trackPageViewGA('/cart/add_ajax.html');
    }
    dcAnalytics.trackEventGA([pageName, 'Donation Amount', frm.proposalid.value, parseInt(donationAmount)]);
    // HEAP TRACKING
    dcAnalytics.track('Added to Shopping Cart', {
        'Page Name': pageName,
        'Add To Cart Price': parseInt(donationAmount),
        'Project Id': parseInt(frm.proposalid.value),
    });
}

export function ajaxAddToCartStatus(data) {
    if (data.message.indexOf('Completed!') > -1 || data.message.indexOf('Expired.') > -1) {
        $('#added' + data.proposalId).html('<p>' + data.message + '</p>');
    } else {
        $('#added' + data.proposalId).html('<a target="_top" class="button-secondary small full-width" href="' + secureBaseURL + 'donors/givingCart.html">Added! Check out</a>');
    }
    if (trim(data.message) != 'Added to cart!') {
        dcAnalytics.trackEventGA([pageName, 'Error - Ajax Add', trim(data.message)]);
        ga('send', 'event', pageName, 'Error - Ajax Add', trim(data.message));
    }
    refreshMiniCartFromDetailsObject(data.sessionMiniCartDetails);
    $('#wishlist' + data.proposalId).hide();
    $('#share' + data.proposalId).hide();
    $('.tooltipTopDouble').hide();
    $('.tooltipTop').hide();
}

function sanitizeAndValidateDonationAmount(form, donationAmountField, showDonationAmountAlertCallback) {
    // Keep this in sync with ValidateAddProposal.MINIMUM_DONATION_AMOUNT
    const MINIMUM_DONATION_AMOUNT = 1;

    const amount = trim(donationAmountField.value.replace('$', '').replace(',', ''));
    donationAmountField.value = amount;
    const regexp = /^[0-9.]+$/;
    if (amount == '' || amount.match(regexp) == null || parseFloat(amount) < MINIMUM_DONATION_AMOUNT) {
        showDonationAmountAlert(form, showDonationAmountAlertCallback);
        return null;
    }
    return amount;
}

// if we see teacherid on the rf param, we'll try to update the challengeId field
function updateChallengeIdFieldBasedOnRFParam(frm) {
    const rfParamTeacherId = getRfParamTeacherId();
    if (typeof teacherChallengeId !== 'undefined' && typeof teacherId !== 'undefined' && rfParamTeacherId != null && parseInt(rfParamTeacherId) != NaN && parseInt(teacherId) == parseInt(rfParamTeacherId)) {
        // [BGK, 2018-05-03] TODO: It appears that the following if-clause will only evaluate to true on the Project Page, so move this function to a Project-Page-specific location.
        // The variables 'teacherChallengeId' and 'teacherId' are available on both the Project Page and the Teacher Page. However, on the Teacher Page, both the Give Widget at the
        // top of the page and the Give Widget inside the live project cards (which can be switched on by clicking the "Show give box" checkbox on the Search Page) already contain
        // an input with name="challengeid", so this if-clause would never be reached from the Teacher Page.
        if ($(frm).find('[name=challengeid]').length === 0) {
            $(frm).append('<input type="hidden" name="challengeid" value="' + teacherChallengeId + '">');
        }

        const alreadyAddedReason = $(frm).find('[name=teacherReferralReason]').length > 0;
        if (!alreadyAddedReason && $(frm).find('[name=challengeid]').val() === teacherChallengeId.toString()) {
            $(frm).append('<input type="hidden" name="teacherReferralReason" value="HAD_REFERRAL_LINK">');
        }
    }
}

// This file can be used in server rendering
if (typeof $ === 'function') {
    // Is any of this still used? It's hard to tell
    $(window).on('signoutTriggered.updateWidgetAmounts', function () {
        $('.addToCart form').show();
        $('.addToCart input[name=donationAmount]').val('');
        $('.actions .share').show();
        $('.addToCart .added').empty();
    });
}
